import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from 'react-toastify';
import cardDesign from "../UsefulComponent/cardDesign";
import FullCardGrid from "../GridViewMain/FullCardGrid/FullCardGrid";
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
Modal.setAppElement("#root");

const TradeModals = ({
  listingUserId,
  thisUserId,
  onTrade,
  prefilteredthisUserCards,
  liveCsrfToken,
  preSelectedCards,

}) => {

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.CardGrid[key][currentLang]; 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [giving, setGiving] = useState([]);
  const [receiving, setReceiving] = useState([preSelectedCards]);
  const [givingCash, setGivingCash] = useState('');
  const [receivingCash, setReceivingCash] = useState('');
  const [thisUserCards, setThisUserCards] = useState([]);
  const [listingUserCards, setListingUserCards] = useState([]);
  const [showThisUserCards, setShowThisUserCards] = useState(true);
  const [showAddCardFrom, setShowAddCardFrom] = useState("");
  const [comment, setComment] = useState("");
  const [whatIsShowing, setWhatIsShowing] = useState("Offer");


  const handleChangeGivingCash = (e) => {
    const input = e.target.value;
    // Regex to allow numbers, commas, and periods
    const regex = /^[\d.,]*$/;

    // Check if the input matches the regex pattern
    if (regex.test(input)) {
      setGivingCash(input);
    }
  };

  const handleChangeReceivingCash = (e) => {
    const input = e.target.value;
    // Regex to allow numbers, commas, and periods
    const regex = /^[\d.,]*$/;

    // Check if the input matches the regex pattern
    if (regex.test(input)) {
      setReceivingCash(input);
    }
  };


  const handleCommentChange = async (event) => {
    await setComment(event.target.value);
  };
  //   const fetchThisUserCards = async () => {
  //     try {
  //       const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradingCards/ForTrade/${thisUserId}`);
  //       const json = await res.json();
  //       setThisUserCards(json);
  //       console.log('thisusercards ', json)

  //     } catch (error) {
  //       console.log('Error fetching card data:', error);
  //     }
  //   };
 
  const fetchListingUserCards = async () => {
    try {

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradingCards/ForTrade/${listingUserId}`
     , {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const json = await res.json();
      console.log("lisitngUsercards ", json);
      setListingUserCards(json);
    } catch (error) {
      console.log("Error fetching card data:", error);
    }
  };
   
  useEffect(() => {
    fetchListingUserCards();
    console.log("prefilteredthisUserCards : ", prefilteredthisUserCards);
    setThisUserCards(prefilteredthisUserCards);
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setGiving([]);
    setReceiving([]);
  };

  const calculateTradeValueSum = (cards) => {
    return cards.reduce((sum, card) => sum + card.tradeValue, 0);
  };

  const getGivingValueSum = () => {
    return calculateTradeValueSum(giving);
  };

  // Function to get the sum of tradeValues for the wanted cards
  const getReceivingValueSum = () => {
    return calculateTradeValueSum(receiving);
  };

  const handleCardSelect = (selectedCard) => {
    console.log("am trying to select this card", selectedCard);
    if (selectedCard.UserId === thisUserId) {
      console.log("I am this userId ", thisUserId);
      if (giving.includes(selectedCard)) {
        setGiving(giving.filter((card) => card !== selectedCard));
      } else {
        setGiving([...giving, selectedCard]);
      }
    } else if (selectedCard.UserId === listingUserId) {
      console.log("I am this seller userId ", listingUserId);
      if (receiving.includes(selectedCard)) {
        setReceiving(receiving.filter((card) => card !== selectedCard));
      } else {
        setReceiving([...receiving, selectedCard]);
      }
    }
  };

  const handleTrade = () => {
   
    console.log('test ma grands')
    onTrade(giving);
    sendTradeOffer(thisUserId, giving,givingCash, listingUserId, receiving,receivingCash);
    closeModal();
    resetAll()
  };
  function buildCardDataArray(cards) {
    console.log('cards buildcardData',cards)
    return cards.map((card) => ({ userCardId: card.userCardId }));
  }

  function sendTradeOffer(thisUserId, giving,givingCash, listingUserId, receiving,receivingCash) {
    const givingData = buildCardDataArray(giving);
    const receivingData = buildCardDataArray(receiving);
     
     // Default givingCash and receivingCash to '0' if null or empty
  const givingCashValue = givingCash.trim() ? givingCash : '0';
  const receivingCashValue = receivingCash.trim() ? receivingCash : '0';

  // Convert givingCashValue and receivingCashValue from string to double
  const givingCashDouble = parseFloat(givingCashValue.replace(',', '.'));
  const receivingCashDouble = parseFloat(receivingCashValue.replace(',', '.'));

  // Check if parsing was successful
  if (isNaN(givingCashDouble) || isNaN(receivingCashDouble)) {
    console.error('Invalid format for givingCash or receivingCash');
    // Optionally handle the error or return early
    return;
  }

  // Use givingCashDouble and receivingCashDouble for further processing
  console.log('Giving Cash (double):', givingCashDouble);
  console.log('Receiving Cash (double):', receivingCashDouble);

    console.log("thisUserId", thisUserId, giving, listingUserId, receiving);
    // Log the data
    console.log("thisUserId", thisUserId);
    console.log("Offer:", givingData);
    console.log("ListingUserId:", listingUserId);
    console.log("Wanted:", receivingData);
    if (givingData.length > 0 && receivingData.length > 0) {
      submitTradeOffer(
        thisUserId,
        givingData,
        givingCashDouble,
        listingUserId,
        receivingData,
        receivingCashDouble,
        comment
      );
      console.log("Offer Send");
    } else console.log("Trade is not completed.");
  }
  function resetAll() {
    setGiving([]);
    setGivingCash('')
    setReceiving([]);
    setReceivingCash('')
    setComment("");
    console.log("Everything as been reset");

  }
  async function submitTradeOffer(
    thisUserId,
    givingData,
    givingCashDouble,
    listingUserId,
    receivingData,
    receivingCashDouble,
    comments
  ) {
    try {
      // Construct the request payload
      const requestData = {
        thisUserId: thisUserId,
        offerData: givingData,
        offerCash: givingCashDouble,
        otherUserId: listingUserId,
        wantedData: receivingData,
        wantedCash: receivingCashDouble,
        comments: comments,
        IsItACounterOffer: false,
        liveCsrfToken: liveCsrfToken, // Include CSRF token for validation
      };
  
      // Send the POST request with credentials
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/tradePlace/submitTradeOffer`,
        requestData,
        {
          withCredentials: true, // Include credentials with the request
        }
      );
  
      // Handle the response from the server
      if (response.data.success) {
        // Trade offer was submitted successfully
        console.log("Trade Offer Submitted:", response.data);
        toast.success(t("TradeOfferSubmittedSuccess"));
        resetAll();
      } else {
        // Trade offer submission failed
        console.error("Failed to submit trade offer:", response.data.error);
        toast.error(t("TradeOfferSubmissionFailed"));
      }
    } catch (error) {
      // Handle any unexpected errors during the request
      console.error("Error submitting trade offer:", error);
      toast.error(t("TradeOfferSubmissionError"));
    }
  }
  const toggleAddCards = (section) => {
    if (section === "giving") {
      setShowAddCardFrom("giving");
      setShowThisUserCards(false);
    } else if (section === "receiving") {
      setShowAddCardFrom("receiving");
      setShowThisUserCards(false);
    }
  };

  const ShowCompleteCard = ({ formData, showData }) => {
    // Ensure this matches the structure and class names in your SCSS
    console.log("current card sale modal formdata", formData);
    return (
      <div
        className="cardcontentForm"
        style={{
          maxHeight: "250px",
        }}
      >
        <div className="card">
          <div className="img" style={{ height: "200px" }}>
            <img
              className="card-image small"
              src={formData.Image}
              alt="Card Preview"
            />

            {/* <div className="card-isWhat">
              {formData.IsRookie === 1 && (
                <div className="patch spe">
                  <p className="strong">RC</p>
                </div>
              )}
              {formData.IsPatch === 1 && (
                <div className="patch">
                  <p>Patch</p>
                </div>
              )}
              {formData.IsJersey === 1 && (
                <div className="patch">
                  <p>Jersey</p>
                </div>
              )}
              {formData.IsAuto === 1 && (
                <div className="patch">
                  <p>Auto</p>
                </div>
              )}
              {formData.IsTribute === 1 && (
                <div className="patch">
                  <p>Tribute</p>
                </div>
              )}
            </div> */}
          </div>
          <div className="txt">
            {showData ? (
              <>
                <div className="justify">
                  <h4 className="card-name">{formData.Name}</h4>

                  <p className="card-IDcard ">#{formData.NumberBehind}</p>
                </div>
                <p className="card-set">{formData.SetName}</p>
                <div className="flex-h">
                  <p className="card-variation">{`${formData.cardName} - ${formData.variationName}`}</p>
                  {formData.Numbered && formData.Numbered !== "0" ? (
                    <p className="card-numbered"> / {formData.Numbered} </p>
                  ) : null}
                </div>
                <div className="flex-h">
                  {/* <div className="justify bottom"> */}
                  <h4 className="card-value">{formData.EstimateValue}$</h4>
                  {/* CTA section, if needed */}

                  <div className="card-isfor">
                    {formData.isForSale && (
                      <div className="patch ">
                        <p>{t('ForSale')}</p>
                      </div>
                    )}
                    {formData.isPC && (
                      <div className="patch ">
                        <p>{t('PC')}</p>
                      </div>
                    )}
                    {formData.isForTrade && (
                      <div className="patch">
                        <p>{t('ForTrade')}</p>
                      </div>
                    )}
                    {formData.isOnEbay && (
                      <div className="patch">
                        <p>{t('OnEbay')}</p>
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}
              </>
            ) : (
              <>
                {" "}
                <h4 className="card-value">{formData.EstimateValue}$</h4>
              </>
            )}
          </div>
        </div>
        {/* {formData.ImageBack && (
                <div className="mt-2 text-left">
                  <label>Back</label>
                  <img src={formData.ImageBack} alt="Selected" className="card-image" />
                </div>
              )} */}
      </div>
    );
  };

  useEffect(() => {
    setShowAddCardFrom('');
    console.log("giving", giving);
    console.log("receiving", receiving);
    //selectedCards.includes(card.id)
  }, [giving,receiving]);

  return (
    <div>
      <button onClick={openModal}>{t('Trade')}</button>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            width: "90%",
            margin: "auto",
            marginTop: "50px",
            background: "black",
            height: "85%",
          },
        }}
      >
        <section className="grid">
          <div style={{ width: "125px",height: "80vh" }}>
            
            {showAddCardFrom===''?(<>
            <div style={{ height: "40vh" }}>
              <h3>({t('You give')})</h3>
              <label>{t('Add Cash')} $ </label>
             
              <input
          type="text"
          value={givingCash}
          onChange={handleChangeGivingCash}
          placeholder="$$" 
          style={{ width: "100px" }}
        />
              <p>Est($) {getGivingValueSum()}</p>

              <button
                style={{ marginTop: "3vh" }}
                onClick={() => toggleAddCards("giving")}
              >
                {t('Add cards')}
              </button>
            </div>

            <div style={{ height: "30vh" }}>
              <h3>({t('You receive')})</h3>
              <label>{t('Add Cash')} $ </label>
            
              <input
          type="text"
          value={receivingCash}
          onChange={handleChangeReceivingCash}
          style={{ width: "100px" }} placeholder="$$"
        />
              <p>Est($) {getReceivingValueSum()}</p>
              <button
                style={{ marginTop: "3vh",marginBottom:"5vh" }}
                onClick={() => toggleAddCards("receiving")}
              >
                {t('Add cards')}
              </button>
           
            </div>
            <button onClick={()=>handleTrade()}style={{marginTop:'5vh'}}>
            {t('Submit Offer')}
              </button>
            </>
          ):null}
          </div>
          <div className="contentfront" style={{ marginTop: "25px" }}>
            {showAddCardFrom === "" ? (
              <>
                <div className="justify top-page">
                  <h2>{t('Select Cards for Trade')}</h2>

                  <button onClick={resetAll}>{t('Clear all')}</button>
                </div>

                {/* <div>
                  <h3>(You give)</h3>
                  <label>Add Cash $ </label>
                  <input style={{ width: "250px" }} placeholder="$$" />
                  <p>Offer Value: {getGivingValueSum()} TV($)</p>
                </div> */}

                <div className="card-grid-wrapper flex-h">
                  {giving.length > 0 ? (
                    giving.map((card, index) => (
                      <>
                        <div className="cardcontent">
                          <div
                            style={{
                              display: "flex",
                              maxWidth: "auto",

                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              key={index}
                              onClick={() => handleCardSelect(card)}
                              style={{
                                cursor: "pointer",
                                border: giving.includes(card)
                                  ? "2px solid #00f"
                                  : "2px solid #000",
                                padding: "5px",
                                margin: "5px",
                                display: "inline-block",
                                // minHeight: "365px",
                                // maxHeight: "500px",
                                minHeight: "260px",
                                maxHeight: "400px",
                              }}
                            >
                              <ShowCompleteCard
                                formData={card}
                                showData={false}
                              />
                            </span>
                          </div>
                        </div>
                      </>
                    ))
                  ) : (
                    <span>{t('Nothing selected')}</span>
                  )}
                </div>

                <div className={"flex-h"} style={{ width: "100%" }}>
                  <h1>
                    VS---------------------------------------------------------------------------------------------------------
                  </h1>
                </div>

                {/* <div>
                  <h3>Wanted Cards(you receive)</h3>
                  <p>Wanted Value: {getReceivingValueSum()} TV($)</p>
                </div>
                <div className="item1-4">
                  <h3>(You receive)</h3>
                  <label>Add Cash $ </label>
                  <input style={{ width: "250px" }} placeholder="$$" />
                  <p>Receiving Value: {getReceivingValueSum()} TV($)</p>
                </div> */}

                <div className="card-grid-wrapper flex-h">
                  {receiving.length > 0 ? (
                    receiving.map((card, index) => (
                      <>
                        <div className="cardcontent">
                          <div
                            style={{
                              display: "flex",
                              maxWidth: "auto",

                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              key={index}
                              onClick={() => handleCardSelect(card)}
                              style={{
                                cursor: "pointer",
                                border: receiving.includes(card)
                                  ? "2px solid #00f"
                                  : "2px solid #000",
                                padding: "5px",
                                margin: "5px",
                                display: "inline-block",
                                // minHeight: "365px",
                                // maxHeight: "500px",
                                minHeight: "250px",
                                maxHeight: "400px",
                              }}
                            >
                              <ShowCompleteCard
                                formData={card}
                                showData={false}
                              />
                            </span>
                          </div>
                        </div>
                      </>
                    ))
                  ) : (
                    <span>{t('Nothing selected')}</span>
                  )}
                </div>
              </>
            ) : (
              <>
                <button style={{marginBottom:'5px'}}onClick={() => setShowAddCardFrom("")}>{t('Go Back')}</button>
                {showAddCardFrom === "giving" ? (
                  <>
                    <FullCardGrid
                      setCards={setThisUserCards}
                      cards={thisUserCards}
                      groupedCards={[]}
                      viewAsGrid={false}
                      viewOnly={true}
                      cardGridType={"CardGridTrade"}
                      MultiCardOfferSelection={true}
                      SetMultiCardOfferSelection={setGiving}
                      
                    />
                  </>
                ) : showAddCardFrom === "receiving" ? (
                  <>
                    <FullCardGrid
                      setCards={setListingUserCards}
                      cards={listingUserCards}
                      groupedCards={[]}
                      viewAsGrid={false}
                      viewOnly={true}
                      cardGridType={"CardGridTrade"}
                      MultiCardOfferSelection={true}
                      SetMultiCardOfferSelection={setReceiving}
                      preSelectedCards={preSelectedCards.id}
                    />
                  </>
                ) : null}
              </>
            )}
          </div>
        </section>

        {/* Cards List */}
        {/* <div>
              {showThisUserCards ? (
                thisUserCards.length > 0 ? (
                  <div className="grid flex-h" style={{ height: "100%" }}>
                    {thisUserCards.map((card, index) => (
                      <span
                        key={index}
                        onClick={() => handleCardSelect(card)}
                        style={{
                          cursor: "pointer",
                          border: giving.includes(card)
                            ? "2px solid #00f"
                            : "2px solid #000",
                          padding: "5px",
                          margin: "5px",
                          display: "inline-block",
                        }}
                      >
                        <ShowCompleteCard formData={card} />
                      </span>
                    ))}
                  </div>
                ) : (
                  <span>List is Empty</span>
                )
              ) : listingUserCards.length > 0 ? (
                <div className="flex-h">
                  {listingUserCards.map((card, index) => (
                    <span
                      key={index}
                      onClick={() => handleCardSelect(card)}
                      style={{
                        cursor: "pointer",
                        border: receiving.includes(card)
                          ? "2px solid #00f"
                          : "2px solid #000",
                        padding: "5px",
                        margin: "5px",
                        display: "inline-block",
                      }}
                    >
                       <div>
              <p>{card.cardName}</p>
              <p>{card.variationName}</p>
              <p>{card.Name}</p>
              <p>Card Index: {index}</p>
              <p>Card ID: {card.CardId}</p>
              <img
                width="150px"
                height="150px"
                src={card.Image}
                alt={`Card ${index}`}
              />
            </div> 
                      <ShowCompleteCard formData={card} />
                    </span>
                  ))}
                </div>
              ) : (
                <h3>No seller's card selected yet</h3>
              )}
            </div> */}

        {/* <div class="page-container" style={{ maxHeight: "400px" }}>
          <div class="section-black" style={{ maxHeight: "400px" }}> */}
        {/* <div className="card-grid-container" style={{height:'80%'}}> */}
        {/* {showThisUserCards ? (
              thisUserCards.length > 0 ? (
                <div className="grid flex-h" style={{ maxHeight: "400px" }}>
                  {thisUserCards.map((card, index) => (
                    <span
                      key={index}
                      onClick={() => handleCardSelect(card)}
                      style={{
                        cursor: "pointer",
                        border: giving.includes(card)
                          ? "2px solid #00f"
                          : "2px solid #000",
                        padding: "5px",
                        margin: "5px",
                        display: "inline-block",
                        minHeight: "360px",
                      }}
                    >
                      <ShowCompleteCard formData={card} />
                    </span>
                  ))}
                </div>
              ) : (
                <span>List is Empty</span>
              )
            ) : listingUserCards.length > 0 ? (
              <div className="flex-h">
                {listingUserCards.map((card, index) => (
                  <span
                    key={index}
                    onClick={() => handleCardSelect(card)}
                    style={{
                      cursor: "pointer",
                      border: receiving.includes(card)
                        ? "2px solid #00f"
                        : "2px solid #000",
                      padding: "5px",
                      margin: "5px",
                      display: "inline-block",
                    }}
                  >
                  
                    <ShowCompleteCard formData={card} />
                  </span>
                ))}
              </div>
            ) : (
              <h3>No seller's card selected yet</h3>
            )} */}
        {/* 
            <h2>test</h2>
          </div>
      
        </div> */}

        {/* <label>
            Comment:
            <textarea
              value={comment}
              onChange={handleCommentChange}
              maxLength={398}
              rows={4}
              cols={50}
              placeholder="Write a comment for the seller..."
            />
          </label>
          <button
            onClick={handleTrade}
            disabled={giving.length === 0 || receiving.length === 0}
          >
            Send Trade Offer
          </button>
          <button onClick={closeModal}>Close</button> */}
      </Modal>
    </div>
  );
};

export default TradeModals;
